function ContactUS() {
    return (
      <div className="min-h-[80vh] bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-center text-gray-800 dark:text-white mb-12">
            تماس با ما
          </h1>
  
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Office 1 */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border-r-4 border-blue-500 dark:border-blue-400">
              <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-4">
                دفتر شماره 1
              </h2>
              <div className="space-y-3 text-gray-600 dark:text-gray-300">
                <p className="flex items-start">
                  <svg
                    className="w-5 h-5 ml-2 mt-1 text-blue-500 dark:text-blue-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  خرم آباد، کیلومتر ۵ جاده تهران، پردیس دانشگاهی کمالوند
                </p>
                <p className="pr-7">
                  پارک علم و فناوري لرستان، طبقه همکف، شرکت هاویر
                </p>
                <p className="pr-7">کد پستی: ۶۸۱۵۱۴۴۳۱۲</p>
              </div>
            </div>
  
            {/* Office 2 */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border-r-4 border-green-500 dark:border-green-400">
              <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-4">
                دفتر شماره 2
              </h2>
              <div className="space-y-3 text-gray-600 dark:text-gray-300">
                <p className="flex items-start">
                  <svg
                    className="w-5 h-5 ml-2 mt-1 text-green-500 dark:text-green-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  بوشهر، خیابان خلیج فارس، دانشگاه خلیج فارس
                </p>
                <p className="pr-7">بعد از کتابخانه مرکزي، شرکت هاویر</p>
                <p className="pr-7">کد پستی: ۷۵۱۶۹۱۳۸۱۷</p>
              </div>
            </div>
  
            {/* Phone */}
            <div className="md:col-span-2 bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 p-3 sm:p-4 rounded-xl shadow-lg">
  <div className="flex flex-col sm:flex-row items-center justify-between text-white">
    <div className="flex items-center w-full sm:w-auto mb-3 sm:mb-0">
      <div className="bg-white/20 p-1 sm:p-2 rounded-full ml-2 sm:ml-3 mr-2 sm:mr-3">
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      </div>
      <div className="flex-1 sm:flex-none">
        <h2 className="text-base sm:text-lg font-bold">تلفن پاسخگویی ۲۴ ساعته</h2>
        <p className="text-xs sm:text-sm pt-1 text-blue-100 dark:text-blue-200">پاسخگویی سریع در کمتر از ۳ دقیقه</p>
      </div>
    </div>
    <a 
      href="tel:09374683780" 
      className="w-full sm:w-auto text-center text-sm sm:text-xl font-bold bg-white text-blue-600 dark:text-blue-700 px-3 sm:px-4 py-1 sm:py-2 rounded-lg shadow-md hover:bg-gray-100 dark:hover:bg-gray-200 transition-all duration-200"
    >
      ۰۹۳۷۴۶۸۳۷۸۰
    </a>
  </div>
</div>
          </div>
        </div>
      </div>
    );
  }
  
  export default ContactUS;